export default __webpack_public_path__ + "static/media/Poppins-Bold.e2abc8f5.ttf";